<template>
  <container-component class="altura-componente-container">
    <router-view/>
  </container-component>
</template>

<script>
import ContainerComponent from '@/views/components/Container.vue'

export default {
    name: 'Relatorios',
    components: {ContainerComponent}
}
</script>

<style lang="stylus">

.container-relatorio
  display flex
  flex-direction row
  min-height 50vh

.container-tipos-relatorios
  display flex
  flex-direction column
  margin-right 10px
  background-color #ddd
  width 300px

.item-relatorio
  padding 5px 10px
  font-weight 450
  border-bottom 1px solid #666

.item-relatorio:hover
  cursor pointer

.item-no-select:hover
  background-color var(--theme-primary)
  color white

.item-selecionado
  background-color var(--theme-primary)
  color white
  padding-right 0px

  &::after
    content ''
    float right
    border-top 10px solid transparent
    border-bottom 10px solid transparent
    border-right 10px solid white
    min-height 0
    margin-top 2px


.item-disabled
  color #7f7f7f

.item-disabled:hover
  cursor not-allowed !important

</style>